module.exports = __webpack_public_path__ + "static/media/startup.a3a3db0f.png";